import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppRow from "src/commun/composants/grille/AppRow";
import styles from "./AppTuile.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppState } from "src/app/state/StateProvider";
import { ActiveService } from "src/domain/User";
import { ajouterFavori, fetchFavoris } from "src/app/api/AccountApi";
import AppIcon from "src/commun/composants/AppIcon";
import Stack from "react-bootstrap/Stack";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";
import AppAsyncImage from "src/commun/composants/AppAsyncImage/AppAsyncImage";
import parse from "html-react-parser";

export type AppTuileProps = {
  service: ActiveService;
  canSubscribe: boolean;
  canAddFavori?: boolean;
}

const AppTuile = ({ service, canSubscribe, canAddFavori }: AppTuileProps) => {
  const { tString } = useAppText();
  const navigate = useNavigate();
  const [{ langue, configuration }, dispatch] = useAppState();

  let label;
  let description;
  if (langue === "fr") {
    label = service.labelFr;
    description = service.descriptionFr;
  } else if (langue === "de") {
    label = service.labelDe;
    description = service.descriptionDe;
  } else {
    label = service.labelEn;
    description = service.descriptionEn;
  }


  const refreshFavoris = () => {
    fetchFavoris().then(result => {
      dispatch({ type: "setFavoris", payload: result });
    });
  };

  const addFavori = (codeService: string) => {
    ajouterFavori({ "codeService": codeService }).then(() => {
      refreshFavoris();
    });
  };

  return (
    <AppCol
      lg
      className={`${styles.tuileContainer} ${canSubscribe && styles.tuileContainerSuscribe} ${service.url && "cursor-pointer"}`}
      onClick={() => {
        if (service.url) {
          goToUrl(service.url, service.openInNewTab, navigate);
        }
      }}>
      <AppRow>
        {service.flagNew && <span className={`${styles.flagNew}`}>{tString("service.pub.nouveau")}</span>}
        <AppCol xs={1} className={styles.iconContainer}>
          <AppAsyncImage
            serviceCode={service.serviceCode}
            alt={label} />
        </AppCol>
        <AppCol>
          <Stack>
            <span className={styles.serviceName}>{parse(label)}</span>
            {(service.nbDaysLeft || service.nbDaysLeft === 0) &&
              <span className={styles.serviceJoursRestants}>({service.nbDaysLeft} {tString("service.joursRestants")})</span>}
          </Stack>
        </AppCol>
        {canAddFavori && configuration.activeFavori &&
          <AppCol xs="auto">
            <AppIcon
              title={tString("favoris.ajouter")}
              className={"cursor-pointer bolderOnHover couleurIconBleu"}
              name="star-empty"
              size="15px"
              onClick={(event) => {
                addFavori(service.serviceCode);
                event.stopPropagation();
              }}/>
          </AppCol>
        }
      </AppRow>
      <AppRow>
        <AppCol className={styles.descriptionText}>
          {description}
        </AppCol>
      </AppRow>
      {service.url && (
        <AppRow className={"arrowLine"}>
          {canSubscribe ? (
            <span className={"lblSabonner"} title={tString("global.sabonner")}>
              {tString("global.sabonner")}
            </span>
          ) : (
            <>
              <AppCol/>
              <AppCol xs="auto" className={styles.btnAccederContainer}>
                <AppIcon
                  title={tString("global.acceder")}
                  name={"suivant"}
                  className={styles.btnAcceder}
                />
              </AppCol>
            </>
          )}
        </AppRow>
      )}
    </AppCol>
  );
};

export default AppTuile;
